const initialState = {
    str: ''
}

const seaBookPlaceIssueRed = (state = initialState, action) => {
    switch(action.type){
        case 'SEABOOK_PLACE_ISSUE' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default seaBookPlaceIssueRed